import React from 'react';
import * as DatesUtils from '../../utils/dates';
import * as CurrencyUtils from '../../utils/currency';
import { Languages } from '../../config';
import ActionsBlock from './components/datatable/ActionsBlock';
import { Tooltip, Button, Box } from '@material-ui/core';

const CONFIGURATION = {};

export const allowedActions = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: 'ID',
    id: 'pcb_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Account',
    id: 'pcb_account',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Value Date',
    id: 'pcb_value_date',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>,
    inData: true,
  },

  {
    label: 'Amount',
    id: 'pcb_amount',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },

  {
    label: 'Deptor Name',
    id: 'pcb_debtor_name',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <Tooltip title={<h2>{cellValue}</h2>}>
        <Box>
          {cellValue.length > 30
            ? cellValue.substring(0, 27) + '...'
            : cellValue}
        </Box>
      </Tooltip>
    ),
    inData: true,
  },
  {
    label: 'Description',
    id: 'pcb_description',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Status',
    id: 'pcb_status_desc',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        statusCode={data[rowIndex].pcb_status_code}
        id={data[rowIndex].pcb_id}
        amount={data[rowIndex].pcb_amount}
        date={data[rowIndex].pcb_value_date}
        error={data[rowIndex].pcb_error}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const TableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'asc',
  TABLE_DEFAULT_SORT_KEY: 'pcb_id',
};

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Central Bank Payments',
    [Languages.English]: 'Central Bank Payments',
  },
  table_title: {
    [Languages.Greek]: 'Manage Central Bank  Payments',
    [Languages.English]: 'Manage Central Bank  Payments',
  },
  match_payments: {
    [Languages.Greek]: 'Match Payments',
    [Languages.English]: 'Match Payments',
  },
  description: {
    [Languages.Greek]:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec blandit gravida ligula, a molestie ligula blandit vel. Aenean urna turpis, pellentesque sit amet egestas eu, viverra et ligula. Vestibulum rhoncus arcu augue, eu semper dui pellentesque non.',
    [Languages.English]:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec blandit gravida ligula, a molestie ligula blandit vel. Aenean urna turpis, pellentesque sit amet egestas eu, viverra et ligula. Vestibulum rhoncus arcu augue, eu semper dui pellentesque non.',
  },
  statusCode: {
    [Languages.Greek]: 'Status',
    [Languages.English]: 'Status',
  },
  account: {
    [Languages.Greek]: 'Account',
    [Languages.English]: 'Account',
  },
  dateFrom: {
    [Languages.Greek]: 'Date From',
    [Languages.English]: 'Date From',
  },
  dateTo: {
    [Languages.Greek]: 'Date To',
    [Languages.English]: 'Date To',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
  error: {
    [Languages.Greek]: 'Error',
    [Languages.English]: 'Error',
  },
  fetch_payments: {
    [Languages.Greek]: 'Fetch Payments',
    [Languages.English]: 'Fetch Payments',
  },
};
